import { create } from 'zustand';

import { HiStudyState } from './use-hi-study.model';

export const useHiStudyStore = create<HiStudyState>((set) => ({
  medicalHistory: null,
  setMedicalHistory: (medicalHistory) => set({ medicalHistory }),
}));
